import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { toast } from 'react-toastify'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ProjectsApiService } from 'src/services/projectsApi'
import { ProjectErrorResponse } from 'src/services/projectsApi/interfaces/projects.interface'

interface UseDeleteProjectMutationParams {
  onSuccess?: () => void
}

const deleteProject = async (id: string) => ProjectsApiService.delete(id)

export const useDeleteProjectMutation = ({
  onSuccess,
}: UseDeleteProjectMutationParams = {}) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: deleteProject,
    onError: (error: AxiosError<ProjectErrorResponse>) => {
      toast.error(error.response?.data?.error || 'Failed to delete project')
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKey.GET_PROJECTS] })
      toast.success('Project deleted successfully')
      onSuccess?.()
    },
  })
}
